import { initReactI18next } from "react-i18next";
import { getCurrentLanguage } from "@/helpers/get-current-langage";

import i18n from "i18next";

import ar from "@/locales/ar/translation.json";
import en from "@/locales/en/translation.json";

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: en },
		ar: { translation: ar },
	},
	fallbackLng: "en",
	lng: getCurrentLanguage(),
	debug: false,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
